<div class="user-menu">
  <div (click)="onLogout()" class="user-menu__profile-image">
    <!-- <img src="assets/svg/icons/user.png" alt="user-profile" /> -->
    <span class="logout-round">
      <h3 class="user-initials" *ngIf="user?.initials">{{ user?.initials }}</h3>
    </span>
  </div>
</div>
